const allMonths = { 'Sep': -1, 'Oct': -1, 'Nov': -1, 'Dec': -1, 'Jan': 0, 'Feb': 0, 'Mar': 0, 'Apr': 0, 'May': 0, 'Jun': 0, 'Jul': 0, 'Aug': 0 };


export default (fiscalMonth, fiscalYear) => {
    const getYear = "20" + (parseInt(fiscalYear.slice(-2)) + allMonths[fiscalMonth]).toString();
    return parseInt(getYear);
}